import { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);

  const login = (newToken, userId, mail, fname, lname) => {
    Cookies.set('authToken', newToken, { expires: 7 });
    Cookies.set('userId', userId, { expires: 7 });
    Cookies.set('fname', fname, { expires: 7 });
    Cookies.set('lname', lname, { expires: 7 });
    setToken(newToken);
  };

  const logout = () => {
    Cookies.remove('authToken');
    setToken(null);
  };

  useEffect(() => {
    const storedToken = Cookies.get('authToken');
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
